import styled from "@emotion/styled";
import { SERVICE_STATUS } from "@home-health-notify/domain";
import {
  Avatar,
  Box,
  IconButton,
  Typography,
  TypographyProps,
} from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import { HHNTheme, patientServiceColor } from "hhn-commons";
import theme from "../theme";

type StatusPatientServiceProp = {
  status?: SERVICE_STATUS;
};

type CounterColorProp = {
  backgroundColor: string;
};

export const shouldForwardProp = <CustomProps extends Record<string, unknown>>(
  props: Array<keyof CustomProps>,
  prop: PropertyKey,
): boolean => !props.includes(prop as string);

export const CompanyName = styled(Typography)`
  color: ${props => (props.theme as Theme).palette.primary.main};
  text-align: center;
`;

export const ServicesToPatientText = styled(Typography, {
  shouldForwardProp: prop =>
    shouldForwardProp<StatusPatientServiceProp>(["status"], prop),
})<StatusPatientServiceProp>(({ status }) => ({
  backgroundColor: status ? patientServiceColor(status) : undefined,
  color: HHNTheme.common.white,
  borderRadius: 4,
  padding: "2px 6px",
  fontWeight: 600,
  fontSize: 12,
  lineHeight: "16px",
  display: "inline-block",
}));

export const rightDrawerWidth = "30%";
export const leftDrawerWidth = "50%";

export const RESPONSIVE_DRAWER = {
  WIDE_BP: 1280, // wide breakpoint
  MIN_BP: 960, // min breakpoint
  NARROW_PX: 360,
} as const;

export const responsiveDrawerMedia = {
  wide: `@media (min-width: ${RESPONSIVE_DRAWER.WIDE_BP}px)`,
  narrow: `@media (min-width: ${RESPONSIVE_DRAWER.MIN_BP}px) and (max-width: ${RESPONSIVE_DRAWER.WIDE_BP - 1}px)`,
};

export const TwoColumnLayoutWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
`;

export const ColumnLayoutItem = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<{ columns?: number }>(["columns"], prop),
})<{ columns?: number }>(({ columns = 2 }) => ({
  flexBasis: `${100 / columns}%`,
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
}));

export const AddGroupWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`;

export const StaticIconStyle = styled(IconButton)`
  background-color: ${({ theme }) => (theme as Theme).palette.secondary.light};
`;

export const Counter = styled(Avatar, {
  shouldForwardProp: prop =>
    shouldForwardProp<CounterColorProp>(["backgroundColor"], prop),
})<CounterColorProp>(({ backgroundColor }) => ({
  width: "auto",
  height: "18px",
  padding: "5px 5px",
  borderRadius: "9px / 50%",
  backgroundColor: backgroundColor,
  fontSize: "12px",
  marginLeft: "5px",
}));

export const limitMaxResolutionStyles = {
  flexShrink: 0,
  minWidth: RESPONSIVE_DRAWER.MIN_BP,
  maxWidth: theme.breakpoints.values.xl,
  margin: "0 auto",
};

export type TypographyCustomProps = React.ComponentType<
  TypographyProps<"span", { component: "span" }>
>;
